module.exports = __webpack_public_path__ + "img/screenshot_n_44.6fa93b15.png";